import {useCallback, useMemo, useState} from 'react'
import {LIST_LOAD_LIMIT} from 'consts'
import {requestData} from 'services'
import {useDidMount} from '../../../objects'

export function useCheckFollowRequest() {
  const [hasFollowRequest, setHasFollowRequest] = useState(false)
  const handleCheckFollowRequest = useCallback(() => {
    requestData('giftshop_get_follower_request_list', {
      params: {page: 1, limit: LIST_LOAD_LIMIT},
      onRequestSuccess: ({status, data: {result}}) => {
        if (status === 200) {
          setHasFollowRequest(result.length > 0)
        }
      },
    })
  }, [])
  useDidMount(handleCheckFollowRequest)
  return useMemo(() => ({hasFollowRequest}), [hasFollowRequest])
}
